import { Fragment } from "react";
import { Outlet, Link, NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Collapse from "bootstrap/js/dist/collapse";
import "./navigation.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import * as bootstrap from "bootstrap";

function Navbar() {
  return (
    <Fragment>
      <nav className="navbar navbar-expand-lg  ">
        <div className="container-fluid">
          <Link to={"/"}>
            <img src="/images/MDM Logo.svg" className="navbar-brand"></img>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            // data-bs-toggle="collapse"
            // data-bs-target="#navbarSupportedContent"
            // aria-controls="navbarSupportedContent"
            // aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={() => {
              const navbar = document.getElementById("navbarSupportedContent");
              let collapseInstance = bootstrap.Collapse.getInstance(navbar);

              if (!collapseInstance) {
                collapseInstance = new bootstrap.Collapse(navbar, {
                  toggle: false,
                });
              }

              if (navbar.classList.contains("show")) {
                collapseInstance.hide();
              } else {
                collapseInstance.show();
              }
            }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <NavLink
                style={{ textDecoration: "none" }}
                className="navlink"
                activeClassName="active"
                exact="true"
                to={"/"}
                // to make nav close after choose
                onClick={() => {
                  const navbar = document.getElementById(
                    "navbarSupportedContent"
                  );
                  if (navbar && navbar.classList.contains("show")) {
                    const collapse = new Collapse(navbar, { toggle: true });
                    collapse.hide();
                  }
                }}
              >
                <li className="nav-item">
                  <p className="nav-link ">HOME</p>
                </li>
              </NavLink>
              <NavLink
                className="navlink"
                style={{ textDecoration: "none" }}
                activeclassname="active"
                to={"/projects"}
                // to make nav close after choose
                onClick={() => {
                  const navbar = document.getElementById(
                    "navbarSupportedContent"
                  );
                  if (navbar && navbar.classList.contains("show")) {
                    const collapse = new Collapse(navbar, { toggle: true });
                    collapse.hide();
                  }
                }}
              >
                <li className="nav-item">
                  <p className="nav-link ">PROJECTS</p>
                </li>
              </NavLink>
              <NavLink
                className="navlink"
                style={{ textDecoration: "none" }}
                activeclassname="active"
                to={"/contact"}
                // to make nav close after choose
                onClick={() => {
                  const navbar = document.getElementById(
                    "navbarSupportedContent"
                  );
                  if (navbar && navbar.classList.contains("show")) {
                    const collapse = new Collapse(navbar, { toggle: true });
                    collapse.hide();
                  }
                }}
              >
                <li className="nav-item">
                  <p className="nav-link ">CONTACT US</p>
                </li>
              </NavLink>
              <NavLink
                className="navlink"
                style={{ textDecoration: "none" }}
                activeclassname="active"
                to={"/Booking"}
                // to make nav close after choose
                onClick={() => {
                  const navbar = document.getElementById(
                    "navbarSupportedContent"
                  );
                  if (navbar && navbar.classList.contains("show")) {
                    const collapse = new Collapse(navbar, { toggle: true });
                    collapse.hide();
                  }
                }}
              >
                <li className="nav-item">
                  <p className="nav-link ">BOOKING</p>
                </li>
              </NavLink>
            </ul>
            <div className="d-flex">
              <Link to={"/contact"}>
                <button className="nav-button">Work With us</button>
              </Link>
            </div>
          </div>
        </div>
      </nav>
      <Outlet />
    </Fragment>
  );
}

export default Navbar;
